import React from 'react';
import Badge from '../../../image/stalion__badge.svg';
import Logo from '../../../image/stalion__logo.svg';
import './index.css';

const Booking = () => {
  return (
    <div className="header-booking__wrapper">
        <div className="header-booking">
            <div className="header-booking__header">
                <img src={Logo} alt="Stalion"/>
            </div>
            <div className="header-booking__bottom">
                <div className="header-booking__badge">
                    <img src={Badge} alt=""/>
                </div>
                <h2 className="header-booking__title">High-Performance <br/>Transport of the Future</h2>
                <p className="header-booking__text">
                    An Exclusive combination of personal driver and the highest level of luxury and performance. 
                </p>
                <a href="#booking"  className="header-booking__link">Book Now</a>
            </div>
        </div>
    </div>
  );
}

export default Booking;
